import Vue from 'vue';
import packageTransformer from './../../transformers/package';

const success = (resolve, response) => {
  resolve(packageTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(packageTransformer.fetch(errors));
};

export default pckg => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/packages', packageTransformer.send(pckg))
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/package/store.js